import { useContext } from 'preact/hooks'
import { WidgetContextValue, WidgetContext } from './WidgetProvider'

export const useWidgetContext = (): WidgetContextValue | undefined => useContext(WidgetContext)
